export const isStaleInvitationError = (code: unknown): code is number =>
  code === 5056 || code === 5058 || code === 5059;

export const withoutInvitationToken = (href: string): string => {
  const url = new URL(href);
  url.searchParams.delete('invitation_token');
  return url.pathname + url.search + url.hash;
};
